import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js';
import { Box, Grid, Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Bar } from 'react-chartjs-2';
import { branchesInfo } from '../../feature/api/branch';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  


const Statistics = ({phone}) => {
  const [data,setData] = useState([])
  const [labels,setLabels] = useState([])
  const dispatch = useDispatch()
  const branches = useSelector(state => state.branches.branches)
  const numbers = useSelector(state => state.download.num)
  const isLoadingNumber = useSelector(state => state.download.isLoadingNumber) 
 
  useEffect(()=>{
    dispatch(branchesInfo())
  },[])
  useEffect(()=>{
    let arr = []
    let val = []
   branches?.map((item)=>{
      arr.push(item.Year)
      val.push(Number(item.Count))
   })
   setLabels(arr)
   setData(val)
  
  },[branches])

    
  return (
    <Box bgcolor={"#000"}  display={"flex"} justifyContent={"center"} width="100%"  >
      <Grid container  position={"relative"} width="100%"  display={"flex"} justifyContent={"space-between"}   sx={{backgroundImage:'url(/images/000.jpg)',backgroundAttachment:'fixed',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundSize:'100% 100%'}}>
        <Grid item lg={3} xl={3} md={3} xs={12} sm={12} display="flex"   flexDirection={"column"} gap={3} justifyContent={"space-between"}  p="20px" bgcolor={"#302e2e82"} > 
          {!isLoadingNumber ?
            <Grid item lg={12} xl={12} md={12} xs={12} sm={12} display={"flex"} justifyContent={"space-between"} alignItems={"flex-start"} >
                <Grid item lg={6} xl={6} md={6} sm={6} xs={6} >
                  <img src="/images/receipt.png" alt="" width={"60px"} />
                </Grid>
              
                <Grid item lg={6} xl={6} md={6} sm={6} xs={6} display={"flex"} flexDirection={"column"} >
                  <h3 style={{color:"#fff"}}>{numbers?.orders}</h3>
                  <h6 style={{color:'#fff'}}>فیش صادر شده</h6>
                </Grid> 
              </Grid>
              :
              <Grid item lg={12} xl={12} md={12} sm={12} xs={12} gap={2} display={"flex"} justifyContent={"space-between"} alignItems={"center"} >
                <Grid item lg={6} xl={6} md={6} sm={6} xs={6} >
                <Skeleton variant="rectangular" animation="wave" sx={{ bgcolor: 'grey.300',borderRadius:'10px',padding:'30px'}}/>

                </Grid>
                <Grid item lg={6} xl={6} md={6} sm={6} xs={6} display={"flex"} flexDirection={"column"} gap={2} >
                  <Skeleton variant="rectangular" animation="wave" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
                  <Skeleton variant="rectangular" animation="wave" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
                </Grid>
              </Grid>
          }
          {!isLoadingNumber ?
            <Grid item lg={12} xl={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"flex-start"} >
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} >
                <img src="/images/group.png" alt="" width={"60px"} />
              </Grid>
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} display={"flex"} flexDirection={"column"} >
                <h3 style={{color:"#fff"}}>{numbers?.customers}</h3>
                <h6 style={{color:'#fff'}}>  مشترک </h6>
              </Grid>         
            </Grid>
            :
            <Grid item lg={12} xl={12} md={12} sm={12} xs={12} gap={2} display={"flex"} justifyContent={"space-between"} alignItems={"center"} >
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} >
                <Skeleton variant="rectangular" animation="wave" sx={{ bgcolor: 'grey.300',borderRadius:'10px',padding:'30px'}}/>
              </Grid>
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} display={"flex"} flexDirection={"column"} gap={2} >
                <Skeleton variant="rectangular" animation="wave" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
                <Skeleton variant="rectangular" animation="wave" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
              </Grid>
            </Grid>
          }
          {!isLoadingNumber ?
            <Grid item lg={12} xl={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"flex-start"} >
              <Grid item lg={6} xl={6} md={6} >
                <img src="/images/food.png" alt=""  width={"60px"}/>
              </Grid>
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} display={"flex"} flexDirection={"column"} >
                <h3 style={{color:"#fff"}}>{numbers?.branchs}</h3>
                <h6 style={{color:'#fff'}}>   شعبه فعال </h6>
              </Grid>
            </Grid>
            :
            <Grid item lg={12} xl={12} md={12} sm={12} xs={12} gap={2} display={"flex"} justifyContent={"space-between"} alignItems={"center"} >
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} >
                <Skeleton variant="rectangular" animation="wave" sx={{ bgcolor: 'grey.300',borderRadius:'10px',padding:'30px'}}/>
              </Grid>
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} display={"flex"} flexDirection={"column"} gap={2} >
                <Skeleton variant="rectangular" animation="wave" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
                <Skeleton variant="rectangular" animation="wave" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
              </Grid>
            </Grid>
          }
          {!isLoadingNumber ?
            <Grid item lg={12} xl={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"flex-start"} >
              <Grid item lg={6} xl={6}  md={6}sm={6} xs={6} >
                <img src="/images/person.png" alt="" width={"50px"} />
              </Grid>
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} display={"flex"} flexDirection={"column"} >
                <h3 style={{color:"#fff"}}>{numbers?.employee}</h3>
                <h6 style={{color:'#fff'}}> پرسنل ستادی و عملیاتی  </h6>
              </Grid>
            </Grid>
            :
            <Grid item lg={12} xl={12} md={12} sm={12} xs={12} gap={2} display={"flex"} justifyContent={"space-between"} alignItems={"center"} >
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} >
                <Skeleton variant="rectangular" animation="wave" sx={{ bgcolor: 'grey.300',borderRadius:'10px',padding:'30px'}}/>
              </Grid>
              <Grid item lg={6} xl={6} md={6} sm={6} xs={6} display={"flex"} flexDirection={"column"} gap={2} >
                <Skeleton variant="rectangular" animation="wave" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
                <Skeleton variant="rectangular" animation="wave" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>
              </Grid>
            </Grid>
          }
        </Grid>
          <Grid item lg={9} xl={9} md={9} sm={12} xs={12} display={"flex"} flexDirection={"column"} alignItems={"flex-end"}  gap={3} p="20px">
                    {phone ?<h5>نمودار رشد شعب در دو دهه گذشته </h5> :<h1 style={{width:'300px'}}> نمودار رشد شعب در دو دهه گذشته </h1>}
                    {/* <Box bgcolor={"#EF7C00"} p="10px 30px" borderRadius={"20px"}>
                        <h5 style={{color:"#fff"}}>از سال 84 تا 1401</h5>
                    </Box> */}
                   <Bar
                  
                  
                    options = {{
                      animation: {
                        delay: 2000
                      },
                      responsive: true,
                      plugins: {
                        title :{
                          font:{
                            weight: 'bold',
                            family:'IRANSansWeb'
                          }
                        },
                        
                        
                      },
                      legend: {
                        position: 'top' ,
                        labels: {
                          font: {
                              size: 14,
                              family:'IRANSans',
                              weight:'bold',
                              color:'red'
                          }
                      }
                      },
                      scales: {
                        y: {
                          ticks: { 
                            color: '#fff', 
                            beginAtZero: true, 
                            font: {
                              size: 18,
                              family:'IRANSans',
                              weight:'bold',
                              
                          }
                          
                        }
                        },
                        x: {
                          ticks: { color: '#000', beginAtZero: true ,
                          font: {
                            size: 18,
                            family:'IRANSans',
                            weight:'bold',
                            
                        }
                        }
                        }
                      }
                    }}

                      style={{fontFamily:'IRANSansWeblight(FaNum)'}} data={{
                        
                      labels,
                        datasets: [
                          {
                            label: 'تعداد شعبه',
                            data: data,
                            backgroundColor:["#fff"],
                            borderSkipped: false,

                            
                           
                          },
                          
                        ],
                        color:['#000'],
                        }} />
                </Grid>
                
        </Grid>

    </Box>

      
    
  )
}

export default Statistics
